<template>
  <div>
    <div>
      <img
        class="w-100"
        src="@/assets/Patagonien.jpg"
        alt="Straße in Patagonien mit Bergpanorama"
      >
    </div>

    <div class="p-4">
      <h6 v-if="!showFancyScrollbar">
        Was kann ich für Euer Unternehmen tun?
      </h6>
      <p>
        Ich unterstütze Euch und Euer Unternehmen dabei, Euren individuellen Weg der
        Weiterentwicklung zu finden und zu gehen.
        Durch die richtigen Fragen und Methoden rege ich in Workshops und Coachings
        zum Reflektieren und Hinterfragen
        des Status Quo an, was die Basis für erfolgreiche Veränderungen schafft.
        Dabei steht immer der Mensch im Mittelpunkt,
        von der Einführung von kleinen Work-Hacks für bessere Zusammenarbeit bis zur Neugestaltung
        der Organisationsstruktur.
      </p>
      <p>
        Meine Schwerpunkte liegen dabei in folgenden Bereichen:
        <ul>
          <li>Unternehmenstransformation auf kultureller Ebene</li>
          <li>Organisationsentwicklung mit Schwerpunkt New Work</li>
          <li>Leadership Training und Coaching</li>
          <li>Virtuelle und hybride Zusammenarbeit</li>
          <li>Erlebnisorientierte Teamentwicklung</li>
          <li>Strategische und operative Personalentwicklung</li>
        </ul>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showFancyScrollbar: { type: Boolean, required: true },
  },
};
</script>
